module.exports = __webpack_public_path__ + "public/SiteImages/£White.svg?a40d9b8d";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/£White.svg
// module id = 3325
// module chunks = 8